import { render } from "./AddAddressDialog.vue?vue&type=template&id=91b2aff2&ts=true"
import script from "./AddAddressDialog.vue?vue&type=script&lang=ts"
export * from "./AddAddressDialog.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__